var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "screen" }, [
    _c("div", { staticClass: "screen__line" }, [
      _c("img", { attrs: { src: _vm.quizBlueLine, alt: "" } }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "screen__inner" }, [
      _c("h3", { staticClass: "screen__header heading-tertiary" }, [
        _vm._v(_vm._s(_vm.question)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "screen__counter" }, [
        _c("p", { staticClass: "screen__text heading-tertiary" }, [
          _c("span", { staticClass: "current-page" }, [
            _vm._v(_vm._s(_vm.currentPage)),
          ]),
          _vm._v("\n                 "),
          _c("span", { staticClass: "total-pages" }, [
            _vm._v(" /" + _vm._s(_vm.totalPages)),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "screen__form",
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.onSend.apply(null, arguments)
          },
          input: _vm.changeForm,
        },
      },
      [
        _c("div", { staticClass: "screen__form-item" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.name,
                expression: "name",
              },
            ],
            staticClass: "screen__input",
            class: { "screen__input--error": _vm.nameError },
            attrs: {
              type: "text",
              placeholder: _vm.$t("__quiz_screen_6_placeholder_1"),
              disabled: _vm.isDataFixed,
            },
            domProps: { value: _vm.name },
            on: {
              focus: _vm.onNameFocus,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.name = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "screen__form-item" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.phone,
                expression: "phone",
              },
            ],
            staticClass: "screen__input",
            class: { "screen__input--error": _vm.phoneError },
            attrs: {
              type: "text",
              placeholder: _vm.$t("__quiz_screen_6_placeholder_2"),
              disabled: _vm.isDataFixed,
            },
            domProps: { value: _vm.phone },
            on: {
              keydown: function ($event) {
                return _vm.checkKeyDownOnlyNumeric($event)
              },
              focus: _vm.onPhoneFocus,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.phone = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "screen__form-item" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email",
              },
            ],
            staticClass: "screen__input",
            attrs: {
              type: "email",
              disabled: _vm.isDataFixed,
              placeholder: _vm.$t("__quiz_screen_6_placeholder_3"),
            },
            domProps: { value: _vm.email },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.email = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "screen__buttons" }, [
          _c(
            "button",
            {
              staticClass: "screen__button btn btn-primary",
              attrs: { type: "submit", disabled: _vm.isDataFixed },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("__quiz_button_analysis")) +
                  "\n            "
              ),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }